import { GoogleApiWrapper } from '@watermarkchurch/google-maps-react'
import WCC from 'wcc'

const connectGoogleMaps = GoogleApiWrapper({
  apiKey: WCC.CONSTANTS?.GOOGLE_MAPS_API_KEY,
  libraries: ['places', 'geometry'],
})

export default connectGoogleMaps
